import axios from "axios";

import Config from "../../../config";

const v2_actionMetaDesvincularContaSocial = (canalId) => {
    let url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/meta/canal/${canalId}/desvincular-conta-social`;
    return axios({
        method: "post",
        url: url
    });
};

export default v2_actionMetaDesvincularContaSocial;
